/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import { ixmUserauthV1ProgramTenantServiceCreateProgramTenant } from '@interxfi/api-client/generated/client-functions/ixm-userauth-v1-program-tenant-service-create-program-tenant';
import type { IxmUserauthV1JoinedRealmAccess, IxmUserauthV1ProgramTenantServiceCreateProgramTenantRequest, IxmUserauthV1ProgramTenantServiceCreateProgramTenantResponse } from '@interxfi/types';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { withAuthorizationToken } from '../../api-client';
import { useRealmAuthActiveAccess } from '../../context';
import { useRealmAPIContext } from '../../realm-context';

/**
 * @generated by NormalizedQueryPlugin (post /portal/userauth/v1/program) */

export function buildIxmUserauthV1ProgramTenantServiceCreateProgramTenantKey() { return ['/ixm.userauth.v1.ProgramTenantService/CreateProgramTenant'] as const; }

export function useIxmUserauthV1ProgramTenantServiceCreateProgramTenant(options?: Partial<UseMutationOptions<IxmUserauthV1ProgramTenantServiceCreateProgramTenantResponse | undefined, Error, IxmUserauthV1ProgramTenantServiceCreateProgramTenantRequest, unknown>>, withAccess?: IxmUserauthV1JoinedRealmAccess) {
    const activeAccess = useRealmAuthActiveAccess();
    const { baseUrl, extendKey, token } = useRealmAPIContext(withAccess ?? activeAccess);
    
    return useMutation({
        mutationKey: extendKey(buildIxmUserauthV1ProgramTenantServiceCreateProgramTenantKey()),
        mutationFn: async (request: IxmUserauthV1ProgramTenantServiceCreateProgramTenantRequest) => ixmUserauthV1ProgramTenantServiceCreateProgramTenant(baseUrl, request, withAuthorizationToken(token)),
        ...options
    });
}
